import React from 'react';

import { Icon, Typography } from 'wtb-components';
import clsx from 'clsx';
import uiIcons from 'uiIcons';
import styles from './Warning.module.css';

const Warning = ({ className, message = '', content }) => {

  return (
    <div className={clsx(styles.root, className)} id="personal-info-warning">
      <Icon name={uiIcons.warning} className={styles.icon} role="img" aria-hidden="false" />
      <Typography variant="body2" className={styles.message}>{message}</Typography>
      {content}
    </div>
  );
};

export default Warning;
